module.exports = __webpack_public_path__ + "static/media/what.8bb99fab.gif";


//////////////////
// WEBPACK FOOTER
// ./src/client/images/what.gif
// module id = 220
// module chunks = 0